<template>
  <div class="wrapper">
    <QuickTourOnBoarding/>
    <OnBoarding />
    <DashboardTop />
    <DashboardList />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import OnBoarding from "../../components/onBoarding/onBoarding.vue";
import QuickTourOnBoarding from "../../components/onBoarding/quickTourOnBoarding.vue";
import DashboardList from "@/components/dashboardList/DashboardList.vue";
import DashboardTop from "@/components/dashboardTop/DashboardTop";

export default {
  name: "Dashboard",
  computed: {
    ...mapState(["currentUser"]),
  },
  methods: {
    ...mapActions(["GET_PRESENTATIONS_METRICS"]),
    // responsesForPresentation(presentation) {
    //   return this.responses.filter((r) => r.presentation_id == presentation.id);
    // },
    // emailLink(presentation) {
    //   let body = encodeURIComponent(
    //     `${presentation.welcome_message}\r\r${presentation.link_to_survey}`
    //   );
    //   return `mailto:?subject=TorchMetrics: ${presentation.name}&body=${body}`;
    // },
    // copyLink(presentation) {
    //   try {
    //     window.navigator.clipboard.writeText(presentation.link_to_survey);
    //   } catch (e) {
    //     console.log(e);
    //   }
    //   try {
    //     navigator.clipboard.writeText(presentation.link_to_survey);
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    // removePresentation(presentation) {
    //   if (
    //     confirm(
    //       `Are you sure? The presentation ${presentation.name} will be removed.`
    //     )
    //   ) {
    //     this.DELETE_PRESENTATION(presentation.id);
    //   }
    // },
  },
  mounted() {
    this.GET_PRESENTATIONS_METRICS();
  },
  components: {
    DashboardTop,
    DashboardList,
    OnBoarding,
    QuickTourOnBoarding
  },
};
</script>